var _style, _rect, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 62.3",
    style: {
      enableBackground: "new 0 0 300 62.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C8421C;}\n\t.st1{fill:#111111;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1",
    y: 0,
    className: "st0",
    width: 38.6,
    height: 43.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1",
    className: "st0",
    d: "M38.6,0L19.3,14.4v47.9l19.3-19.2V0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2",
    transform: "translate(48.879 4.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2",
    className: "st1",
    d: "M0.3,14.9c0-6.1,4.1-10.4,10-10.4c5.3,0,9,3.8,9,9.4c0,6.1-4.1,10.3-10,10.3 C4,24.2,0.3,20.4,0.3,14.9 M4.1,14.2c0,5.1,2.3,8.5,5.7,8.5c3.5,0,5.6-3.2,5.6-8.4c0-4.9-2.3-8.3-5.6-8.3 C6.4,5.9,4.1,9.2,4.1,14.2 M5.5,1.6C5.4,0.8,5.9,0.1,6.6,0C6.8,0,6.9,0,7,0c0.8-0.1,1.5,0.5,1.6,1.3c0,0.1,0,0.2,0,0.3 c0.1,0.8-0.5,1.5-1.3,1.5c-0.1,0-0.2,0-0.3,0C6.3,3.2,5.6,2.7,5.5,1.9C5.5,1.8,5.5,1.7,5.5,1.6 M10.9,1.6 c-0.1-0.8,0.5-1.5,1.3-1.6c0.1,0,0.2,0,0.3,0c0.8-0.1,1.5,0.5,1.5,1.3c0,0.1,0,0.2,0,0.3c0.1,0.8-0.5,1.5-1.3,1.6 c-0.1,0-0.2,0-0.3,0c-0.8,0.1-1.5-0.4-1.6-1.2C10.9,1.8,10.9,1.7,10.9,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3",
    className: "st1",
    d: "M21.7,23.3V20h1.9l1.4,2.7c0.3,0,0.5,0,0.6,0c1.7,0,2.7-0.7,2.7-2c0-0.9-0.2-1.2-1.7-2l-2.4-1.4 c-1.8-1.1-2.5-2-2.5-3.6c0-2.2,2-3.9,4.6-3.9c0.6,0,1.2,0.1,1.7,0.1c0.5,0.1,1,0.1,1.3,0.2l1.2,0.3l0.3,0.1v3h-1.9l-1.3-2.4 c-0.1,0-0.2,0-0.3,0c-1.6,0-2.5,0.6-2.5,1.7c0,0.8,0.3,1.2,1.6,1.9l2.5,1.4c1.4,0.7,2.3,2.1,2.3,3.7c0,2.5-2.1,4.3-5,4.3 c-1,0-1.9-0.2-2.8-0.4l-1.3-0.3L21.7,23.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4",
    className: "st1",
    d: "M35,11.3h-2.2v-1l0.3-0.1c2.4-0.8,2.5-0.9,3.5-2.4c0.3-0.5,0.6-1,0.8-1.5h1.1v3.5h4.4v1.4h-4.4 v8.5c0,1.9,0.6,2.5,2.6,2.5c0.3,0,0.6,0,0.9-0.1l0.8-0.1l0.2,0l0.3,1.1l-0.3,0.1l-1.5,0.4c-1,0.2-2,0.4-3,0.4 c-2.3,0-3.4-1.1-3.4-3.4L35,11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5",
    className: "st1",
    d: "M56.4,16.6h-9c0,3.6,2,5.7,5.3,5.7c1.1,0,2.2-0.2,3.2-0.4l0.2,1.1c-1.8,0.7-3.8,1.1-5.7,1.2 c-4.1,0-6.6-2.6-6.6-6.8c0-4.3,2.9-7.5,6.8-7.5c2.4,0,4.1,0.8,4.9,2.4C56.1,13.4,56.3,14.2,56.4,16.6 M52.6,15.1 c-0.1-3-0.7-4.2-2.4-4.2c-1.8,0-2.8,1.6-2.8,4.7L52.6,15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_6",
    className: "st1",
    d: "M63.9,12.1V22l3,1v0.8H58V23l2.4-1v-9.9L58,11.4v-0.8l5.9-1v1.8l0.3-0.2c2.2-1.2,3.2-1.6,4.1-1.6 c0.6,0,1.2,0.2,1.8,0.5v3.5h-2.9l-0.8-1.8c-0.3,0-0.5-0.1-0.7-0.1C65.1,11.8,64.5,11.9,63.9,12.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_7",
    className: "st1",
    d: "M77.1,12.1V22l3,1v0.8h-8.9V23l2.4-1v-9.9l-2.4-0.7v-0.8l5.9-1v1.8l0.3-0.2 c2.2-1.2,3.2-1.6,4.1-1.6c0.6,0,1.2,0.2,1.8,0.5v3.5h-2.9l-0.8-1.8c-0.3,0-0.5-0.1-0.7-0.1C78.3,11.8,77.7,11.9,77.1,12.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_8",
    className: "st1",
    d: "M96.4,16.6h-9c0,3.6,2,5.7,5.3,5.7c1.1,0,2.2-0.2,3.2-0.4l0.2,1.1c-1.8,0.7-3.8,1.1-5.7,1.2 c-4.1,0-6.6-2.6-6.6-6.8c0-4.3,2.9-7.5,6.8-7.5c2.4,0,4.1,0.8,4.9,2.4C96.2,13.4,96.4,14.2,96.4,16.6 M92.6,15.1 c-0.1-3-0.7-4.2-2.4-4.2c-1.8,0-2.8,1.6-2.8,4.7L92.6,15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_9",
    className: "st1",
    d: "M100.5,22v-9.9l-2.4-0.7v-0.8l6-1.1V22l2.4,1v0.8h-8.5V23L100.5,22z M100.1,5.7 c0-1.1,0.7-1.6,2.1-1.6c1.6,0,2.2,0.5,2.2,1.5c0,1.1-0.6,1.6-2.1,1.6C100.7,7.2,100.1,6.8,100.1,5.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10",
    className: "st1",
    d: "M119.5,10.4v3.2h-2.4l-1.3-2.6h-0.2c-2.5,0-4.3,2.4-4.3,5.6c0,3.6,2,5.7,5.4,5.7 c0.8,0,1.6-0.1,2.4-0.3l0.3-0.1l0.2,1.1c-1.8,0.6-3.6,1-5.5,1.1c-3.5,0.1-6.5-2.6-6.6-6.1c0-0.2,0-0.4,0-0.6 c0-4.5,3.2-7.5,7.9-7.5C116.8,9.8,118.2,10,119.5,10.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11",
    className: "st1",
    d: "M126.7,12v10l2.1,1v0.8h-8V23l2.4-1V6.3l-2.6-0.7V4.8l6-1.1v7.5l0.3-0.1 c1.5-0.7,3.1-1.1,4.8-1.3c1,0,2,0.4,2.6,1.2c0.8,0.9,1,1.8,1,3.5V22l2.4,1v0.8H130V23l2-1v-6.7c0-2.6-0.8-3.6-2.9-3.6 C128.3,11.7,127.5,11.8,126.7,12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_12",
    className: "st1",
    d: "M141.4,22v-9.9l-2.4-0.7v-0.8l6-1.1V22l2.4,1v0.8H139V23L141.4,22z M141,5.7 c0-1.1,0.7-1.6,2.1-1.6c1.6,0,2.2,0.5,2.2,1.5c0,1.1-0.6,1.6-2.1,1.6C141.6,7.2,141,6.8,141,5.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13",
    className: "st1",
    d: "M149.2,23.3V20h1.9l1.4,2.7c0.3,0,0.5,0,0.6,0c1.7,0,2.7-0.7,2.7-2c0-0.9-0.2-1.2-1.7-2 l-2.4-1.4c-1.8-1.1-2.5-2-2.5-3.6c0-2.2,2-3.9,4.6-3.9c0.6,0,1.2,0.1,1.7,0.1c0.5,0.1,1,0.1,1.3,0.2l1.2,0.3l0.3,0.1v3h-1.9 l-1.3-2.4c-0.1,0-0.2,0-0.3,0c-1.6,0-2.5,0.6-2.5,1.7c0,0.8,0.3,1.2,1.6,1.9l2.5,1.4c1.4,0.7,2.3,2.1,2.3,3.7c0,2.5-2.1,4.3-5,4.3 c-1,0-1.9-0.2-2.8-0.4l-1.3-0.3L149.2,23.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14",
    className: "st1",
    d: "M172.8,10.4v3.2h-2.4L169,11h-0.2c-2.5,0-4.3,2.4-4.3,5.6c0,3.6,2,5.7,5.4,5.7 c0.8,0,1.6-0.1,2.4-0.3l0.3-0.1l0.2,1.1c-1.8,0.6-3.6,1-5.5,1.1c-3.5,0.1-6.5-2.6-6.6-6.1c0-0.2,0-0.4,0-0.6 c0-4.5,3.2-7.5,7.9-7.5C170,9.8,171.4,10,172.8,10.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15",
    className: "st1",
    d: "M180,12v10l2.1,1v0.8h-8V23l2.4-1V6.3l-2.6-0.7V4.8l6-1.1v7.5l0.3-0.1c1.5-0.7,3.1-1.1,4.8-1.3 c1,0,2,0.4,2.6,1.2c0.8,0.9,1,1.8,1,3.5V22l2.4,1v0.8h-7.9V23l2-1v-6.7c0-2.6-0.8-3.6-2.9-3.6C181.5,11.7,180.7,11.8,180,12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_16",
    className: "st1",
    d: "M204.6,16.6h-9c0,3.6,2,5.7,5.3,5.7c1.1,0,2.2-0.2,3.2-0.4l0.2,1.1c-1.8,0.7-3.8,1.1-5.7,1.2 c-4.1,0-6.6-2.6-6.6-6.8c0-4.3,2.9-7.5,6.8-7.5c2.4,0,4.1,0.8,4.9,2.4C204.4,13.4,204.6,14.2,204.6,16.6 M200.8,15.1 c-0.1-3-0.7-4.2-2.4-4.2c-1.8,0-2.8,1.6-2.8,4.7L200.8,15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_17",
    className: "st1",
    d: "M13.2,33.3v0.8l2.3,1v11L5.6,33.3H0v0.8l2.4,1v15.4l-2.4,1v0.8h6.6v-0.8l-2.3-1V37.4l11.6,15.1 h1.5V35.1l2.4-1v-0.8L13.2,33.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_18",
    className: "st1",
    d: "M25.8,39.4l-1.3,2.6h-2.6v-2.7c1.9-0.6,3.8-1,5.8-1.1c1-0.1,2.1,0.2,3,0.6 c1.1,0.6,1.4,1.2,1.4,2.8v8c0,0.3,0.3,0.5,0.9,0.7l1.5,0.4v0.8l-0.3,0.1L33,52c-0.7,0.2-1.1,0.3-1.3,0.3c-0.4,0.1-0.8,0.2-1.2,0.2 c-0.9,0-1.4-0.4-1.8-1.5c-1.3,0.8-2.7,1.4-4.2,1.5c-2,0.1-3.6-1.4-3.8-3.3c0-0.1,0-0.2,0-0.2c-0.1-1.6,1.1-3.1,2.7-3.4 c1.7-0.4,3.4-0.6,5.1-0.7v-3.3c0-1.6-0.5-2.2-2-2.2c-0.1,0-0.2,0-0.7,0C25.9,39.4,25.9,39.4,25.8,39.4 M28.6,45.8l-0.4,0.1 L27,46.1c-2.1,0.4-2.6,0.9-2.6,2.2c0,1.2,0.9,2.2,2.1,2.2c0.1,0,0.2,0,0.3,0c0.6,0,1.3-0.1,1.9-0.3L28.6,45.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_19",
    className: "st1",
    d: "M37.2,39.8H35v-1l0.3-0.1c2.4-0.8,2.5-0.9,3.5-2.4c0.3-0.5,0.6-1,0.8-1.5h1.1v3.5h4.4v1.4h-4.4 v8.5c0,1.9,0.6,2.5,2.6,2.5c0.3,0,0.6,0,0.9-0.1l0.8-0.1l0.2,0l0.3,1.1l-0.3,0.1l-1.5,0.4c-1,0.2-2,0.4-3,0.4 c-2.3,0-3.4-1.1-3.4-3.4L37.2,39.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_20",
    className: "st1",
    d: "M49.3,50.4v-9.9l-2.4-0.7v-0.8l6-1.1v12.4l2.4,1v0.8h-8.5v-0.8L49.3,50.4z M48.8,34.1 c0-1.1,0.7-1.6,2.1-1.6c1.6,0,2.2,0.5,2.2,1.5c0,1.1-0.6,1.6-2.1,1.6C49.4,35.7,48.8,35.3,48.8,34.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_21",
    className: "st1",
    d: "M56.2,45.7c-0.2-3.9,2.8-7.3,6.7-7.5c0.3,0,0.5,0,0.8,0c4.4,0,7.2,2.8,7.2,7 c0.2,3.9-2.8,7.3-6.7,7.5c-0.3,0-0.5,0-0.8,0C59.1,52.7,56.2,49.9,56.2,45.7 M60.1,45.1c0,3.8,1.3,6.1,3.5,6.1s3.5-2,3.5-5.6 c0-3.8-1.4-6.2-3.5-6.2S60.1,41.6,60.1,45.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_22",
    className: "st1",
    d: "M78.3,40.6v9.9l2.2,1v0.8h-8v-0.8l2.4-1v-9.9l-2.4-0.7v-0.8l5.9-1.1v1.6l0.3-0.1L80,39 c0.8-0.3,1.4-0.5,1.6-0.6c0.5-0.2,1.1-0.2,1.6-0.2c1-0.1,2.1,0.4,2.7,1.2c0.7,0.9,0.9,1.7,0.9,3.6v7.5l2.4,1v0.8h-7.7v-0.8l1.8-1 v-6.6c0-2.7-0.7-3.5-2.9-3.5C79.8,40.3,79,40.4,78.3,40.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_23",
    className: "st1",
    d: "M95.7,39.4l-1.3,2.6h-2.6v-2.7c1.9-0.6,3.8-1,5.7-1.1c1-0.1,2.1,0.2,3,0.6 c1.1,0.6,1.4,1.2,1.4,2.8v8c0,0.3,0.3,0.5,0.9,0.7l1.5,0.4v0.8l-0.3,0.1l-1.3,0.4c-0.7,0.2-1.1,0.3-1.3,0.3 c-0.4,0.1-0.8,0.2-1.2,0.2c-0.9,0-1.4-0.4-1.8-1.5c-1.3,0.8-2.7,1.4-4.2,1.5c-2,0.1-3.6-1.4-3.8-3.3c0-0.1,0-0.2,0-0.2 c-0.1-1.6,1.1-3.1,2.7-3.4c1.7-0.4,3.4-0.6,5.1-0.7v-3.3c0-1.6-0.5-2.2-2-2.2c-0.1,0-0.2,0-0.7,0C95.8,39.4,95.8,39.4,95.7,39.4  M98.5,45.8l-0.4,0.1l-1.3,0.3c-2.1,0.4-2.6,0.9-2.6,2.2c0,1.2,0.9,2.2,2.1,2.2c0.1,0,0.2,0,0.3,0c0.6,0,1.3-0.1,1.9-0.3 L98.5,45.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_24",
    className: "st1",
    d: "M105.1,33.3v0.8l2.6,0.7v15.7l-2.4,1v0.8h8.4v-0.8l-2.6-1V32.1L105.1,33.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_25",
    className: "st1",
    d: "M116.6,51.8V34.7l-2.6-0.7v-0.8l6-1.1v7.7l0.3-0.1l1.5-0.7c0.9-0.5,1.9-0.8,3-0.8 c2.9,0,5.2,2.8,5.2,6.5c0,4.6-3.4,7.9-8.3,7.9c-1.1,0-2.2-0.2-3.3-0.3l-1.5-0.3L116.6,51.8z M120.1,50.9c0.4,0.1,0.8,0.2,1.2,0.2 c3,0,4.9-2.2,4.9-5.6c0-3.2-1.7-5.3-4.3-5.3c-0.6,0-1.2,0.1-1.8,0.3L120.1,50.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_26",
    className: "st1",
    d: "M134.2,50.4v-9.9l-2.4-0.7v-0.8l6-1.1v12.4l2.4,1v0.8h-8.5v-0.8L134.2,50.4z M133.8,34.1 c0-1.1,0.7-1.6,2.1-1.6c1.6,0,2.2,0.5,2.2,1.5c0,1.1-0.6,1.6-2.1,1.6C134.4,35.7,133.8,35.3,133.8,34.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_27",
    className: "st1",
    d: "M142.5,51.8V34.7l-2.6-0.7v-0.8l6-1.1v7.7l0.3-0.1l1.5-0.7c0.9-0.5,1.9-0.8,3-0.8 c2.9,0,5.2,2.8,5.2,6.5c0,4.6-3.4,7.9-8.3,7.9c-1.1,0-2.2-0.2-3.2-0.3l-1.5-0.3L142.5,51.8z M145.9,50.9c0.4,0.1,0.8,0.2,1.2,0.2 c3,0,4.9-2.2,4.9-5.6c0-3.2-1.7-5.3-4.3-5.3c-0.6,0-1.2,0.1-1.8,0.3L145.9,50.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_28",
    className: "st1",
    d: "M156.4,33.3v0.8l2.6,0.7v15.7l-2.4,1v0.8h8.4v-0.8l-2.6-1V32.1L156.4,33.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_29",
    className: "st1",
    d: "M168.6,50.4v-9.9l-2.4-0.7v-0.8l6-1.1v12.4l2.4,1v0.8h-8.5v-0.8L168.6,50.4z M168.2,34.1 c0-1.1,0.7-1.6,2.1-1.6c1.6,0,2.2,0.5,2.2,1.5c0,1.1-0.6,1.6-2.1,1.6C168.8,35.7,168.2,35.3,168.2,34.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_30",
    className: "st1",
    d: "M175.6,45.7c-0.2-3.9,2.8-7.3,6.7-7.5c0.3,0,0.5,0,0.8,0c4.4,0,7.2,2.8,7.2,7 c0.2,3.9-2.8,7.3-6.7,7.5c-0.3,0-0.5,0-0.8,0C178.4,52.7,175.6,49.9,175.6,45.7 M179.4,45.1c0,3.8,1.3,6.1,3.5,6.1s3.5-2,3.5-5.6 c0-3.8-1.4-6.2-3.5-6.2S179.4,41.6,179.4,45.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_31",
    className: "st1",
    d: "M193.3,39.8h-2.2v-1l0.3-0.1c2.4-0.8,2.5-0.9,3.5-2.4c0.3-0.5,0.6-1,0.8-1.5h1.1v3.5h4.4v1.4 h-4.4v8.5c0,1.9,0.6,2.5,2.6,2.5c0.3,0,0.6,0,0.9-0.1l0.8-0.1l0.2,0l0.3,1.1l-0.3,0.1l-1.5,0.4c-1,0.2-2,0.4-3,0.4 c-2.3,0-3.4-1.1-3.4-3.4L193.3,39.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_32",
    className: "st1",
    d: "M208.4,40.5v10l2.1,1v0.8h-8v-0.8l2.4-1V34.7l-2.6-0.7v-0.8l6-1.1v7.5l0.3-0.1 c1.5-0.7,3.1-1.1,4.8-1.3c1,0,2,0.4,2.6,1.2c0.8,0.9,1,1.8,1,3.5v7.5l2.4,1v0.8h-7.9v-0.8l2-1v-6.7c0-2.6-0.8-3.6-2.9-3.6 C210,40.2,209.2,40.3,208.4,40.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_33",
    className: "st1",
    d: "M233.1,45h-9c0,3.6,2,5.7,5.3,5.7c1.1,0,2.2-0.2,3.2-0.4l0.2,1.1c-1.8,0.7-3.8,1.1-5.7,1.2 c-4.1,0-6.6-2.6-6.6-6.8c0-4.3,2.9-7.5,6.8-7.5c2.4,0,4.1,0.8,4.9,2.4C232.9,41.9,233.1,42.7,233.1,45 M229.3,43.6 c-0.1-3-0.7-4.2-2.4-4.2c-1.8,0-2.8,1.6-2.8,4.7L229.3,43.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_34",
    className: "st1",
    d: "M243.5,38.4v0.8l1.9,0.8l-4.5,4.8l4.9,7.5h5.3v-0.8l-2.1-0.8l-5-7.3l3.8-3.2l2.8-1v-0.8 L243.5,38.4z M234.4,33.3v0.8l2.6,0.7v15.7l-2.4,1v0.8h8v-0.8l-2-1V32.1L234.4,33.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1c8538657669196276280e68050194da.svg";
export { ForwardRef as ReactComponent };